import React from 'react';
import BudgetChangeWorkspace from './BudgetChangeWorkspace';

/** 예산변경승인 */
export default function BudgetChangeApprove() {
  return <BudgetChangeWorkspace screenMode="approve" />;
}
